import { useRef, useEffect } from "react";
import { DivIcon } from "leaflet";
import { Marker, Popup } from "react-leaflet";
import { Link } from "react-router-dom";

const MarkerComponent = ({ boxs, boxId, loading, data }) => {
    const markerRefs = useRef({});

    useEffect(() => {
        if (boxId && markerRefs.current[boxId]) {
            markerRefs.current[boxId].openPopup();
        }
    }, [boxId]);

    const boxIcon = (color) => `
        <svg style="fill: ${color}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="chartreuse" version="1.1" id="Capa_1" width="40px" height="40px" viewBox="0 0 27.37 27.37" xml:space="preserve">
            <g>
                <g>
                    <polygon points="8.332,27.37 19.037,27.37 13.684,11.245   "/>
                    <circle cx="13.684" cy="8.104" r="2.141"/>
                    <path d="M9.522,12.267c0.105,0.104,0.242,0.157,0.379,0.157c0.137,0,0.274-0.052,0.378-0.157c0.209-0.208,0.209-0.547,0-0.756    c-1.877-1.877-1.877-4.934,0-6.811c0.209-0.209,0.209-0.548,0-0.757c-0.208-0.209-0.547-0.209-0.757,0    C7.227,6.236,7.227,9.972,9.522,12.267z"/>
                    <path d="M17.09,12.267c0.104,0.104,0.241,0.157,0.378,0.157s0.274-0.052,0.379-0.157c2.295-2.295,2.295-6.029,0-8.324    c-0.209-0.209-0.548-0.209-0.757,0s-0.209,0.547,0,0.757c1.877,1.877,1.877,4.934,0,6.811    C16.881,11.719,16.881,12.058,17.09,12.267z"/>
                    <path d="M8.386,13.402c-2.921-2.921-2.921-7.675,0-10.598c0.209-0.209,0.209-0.547,0-0.756c-0.209-0.209-0.548-0.209-0.757,0    c-3.337,3.338-3.337,8.772,0,12.11c0.104,0.105,0.242,0.157,0.378,0.157c0.136,0,0.274-0.052,0.378-0.157    C8.595,13.95,8.595,13.611,8.386,13.402z"/>
                    <path d="M19.74,2.048c-0.208-0.209-0.549-0.209-0.758,0c-0.209,0.209-0.209,0.547,0,0.756c2.922,2.922,2.922,7.676,0,10.598    c-0.209,0.209-0.209,0.547,0,0.756c0.104,0.105,0.241,0.157,0.38,0.157c0.137,0,0.273-0.052,0.378-0.157    C23.077,10.82,23.077,5.388,19.74,2.048z"/>
                    <path d="M3.518,8.104c0-2.718,1.057-5.271,2.976-7.191c0.209-0.209,0.209-0.548,0-0.757s-0.548-0.209-0.757,0    c-4.381,4.382-4.381,11.513,0,15.895c0.105,0.104,0.242,0.156,0.379,0.156c0.137,0,0.274-0.052,0.378-0.156    c0.209-0.209,0.209-0.548,0-0.758C4.575,13.375,3.518,10.821,3.518,8.104z"/>
                    <path d="M21.631,0.157c-0.208-0.209-0.547-0.209-0.756,0s-0.209,0.547,0,0.757c1.919,1.919,2.976,4.473,2.976,7.191    c0,2.717-1.057,5.271-2.976,7.189c-0.209,0.209-0.209,0.549,0,0.758c0.104,0.104,0.242,0.156,0.378,0.156s0.273-0.052,0.378-0.156    C26.014,11.669,26.014,4.539,21.631,0.157z"/>
                </g>
            </g>
        </svg>
    `
    const camIcon = (color) => `
                    <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 24 24"><path fill="dodgerblue" d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11z"/></svg>
`

    const customIcon = (name, color) => {
        const result = new DivIcon({
            html: boxIcon(color) + `<div class="font-bold" style="color:chartreuse;width: 110px;text-align: center;position: absolute;left: -70%;">${name}</div>`,
            iconSize: [45, 40],
            className: 'box-icon'
        });
        return result
    }

    const customCamIcon = (name) => {
        const result = new DivIcon({
            html: camIcon() + `<div class="font-bold text-white" style="color:chartreuse;width: 110px;text-align: center;position: absolute;left: -70%;" >${name}</div>`,
            iconSize: [45, 40],
            className: 'box-icon'
        });
        return result
    }

    // function getColor(record, metric) {
    //     if (!record) return "gray-500"

    //     if (Object.keys(record).includes(metric.code)) {
    //         const max = SENSORS_GROUP.info[metric.metric]?.max
    //         if (max && record[metric.code] > max) {
    //             return "red-500"
    //         }
    //         else return "blue-500"
    //     } else return "gray-500"
    // }

    return <>
        {
            boxs?.length > 0 &&
            boxs.map((b, i) => {
                const cdata = data.find(d => d.box.id === b.id)
                const record = cdata && cdata.count > 0 ? cdata.records[0] : {}

                return <Marker icon={b.type === "CAM" ? customCamIcon(b.name) : customIcon(b.name, 'chartreuse')} key={b.id} position={{ lat: b.location.lat, lng: b.location.lng }}
                    ref={el => {
                        if (el) {
                            markerRefs.current[b.id] = el;
                        }
                    }} >
                    <Popup className={"h-[180px] !bottom-8"}>
                        <div className="title">{b.name}</div>
                        <div className="text-gray-700 max-h-[160px] overflow-auto">
                            <div>
                                {b.metrics.map(metric => {
                                    return <div className="item" key={metric.code}>
                                        <div className="title-item"> {metric.name}:</div>
                                        <div className="value-item">{b.id === "KEHF4MGC" ? +record[metric.code] + 15.05 : record[metric.code]} {metric.metric === 'WA' ? ' m' : ' cm'} </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    </Popup>
                </Marker>
            })
        }
    </>
}

export default MarkerComponent